import { Role } from "@/types/graphql";

export const roleTitle = (role: Role): string => {
  return `${role.title}${role.scope ? ":" + role.scope : ""} (${
    role.permissions?.length || 0
  })`;
};
